import React, { FC } from "react";
import { ScrollView, Text, View } from "react-native-web";
import { vw } from "../../../utils/tool/vw";
import { inlineStyles } from "./headerMenuInlineStyles";
import { Item } from "./useHeaderMenu";

interface HeaderMenuCategoriesProps {
  items: Item[];
  isDesktop: boolean;
  onPress: (title: string) => void;
}

export const HeaderMenuCategories: FC<HeaderMenuCategoriesProps> = ({
  items,
  isDesktop,
  onPress,
}) => {
  const renderCategoryItems = () =>
    items.map((item, index) => (
      <View
        key={index}
        style={{
          ...inlineStyles.item,
          ...(item.active ? inlineStyles.activeItem : {}),
        }}
        onClick={() => onPress(item.title)}
      >
        <Text
          style={[
            inlineStyles.ItemText,
            item.active ? inlineStyles.ActiveItemText : {},
          ]}
        >
          {item.label ?? item.title}
        </Text>
      </View>
    ));

  if (isDesktop) {
    return (
      <View style={inlineStyles.categoryRowDesktop}>{renderCategoryItems()}</View>
    );
  }

  return (
    <ScrollView
      horizontal
      showsHorizontalScrollIndicator={false}
      showsVerticalScrollIndicator={false}
      style={{ maxWidth: "103%", marginLeft: vw(5), zIndex: 40 }}
    >
      {renderCategoryItems()}
    </ScrollView>
  );
};
